import type { App } from "vue"

const GlobalProperties = {
  install(app: App) {
    app.config.globalProperties.$log = console.log.bind(console)
  }
}

export default GlobalProperties
